import React, { useRef, useEffect } from 'react';
import { Typography } from '@mui/material';

interface CountdownTimerProps {
    timer: string;
    setTimer: React.Dispatch<React.SetStateAction<string>>;
    timerDurationLabel?: string;
    timerDuration?: number;
    fontSize?: number;
    reset?: boolean;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({
    timer,
    setTimer,
    timerDurationLabel = '01:30',
    timerDuration = 90,
    fontSize = 16,
    reset = false,
}) => {
    const Ref = useRef<NodeJS.Timeout | null>(null);

    const getTimeRemaining = (e: Date) => {
        const total =
            Date.parse(e.toString()) - Date.parse(new Date().toString());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        return {
            total,
            minutes,
            seconds,
        };
    };

    const startTimer = (e: Date) => {
        let { total, minutes, seconds } = getTimeRemaining(e);
        if (total >= 0) {
            setTimer(
                (minutes > 9 ? minutes : '0' + minutes) +
                    ':' +
                    (seconds > 9 ? seconds : '0' + seconds),
            );
        }
    };

    const clearTimer = (e: Date) => {
        setTimer(timerDurationLabel);

        if (Ref.current) clearInterval(Ref.current!); // Use "!" to assert non-null
        const id = setInterval(() => {
            startTimer(e);
        }, 1000);
        Ref.current = id;
    };

    const getDeadTime = () => {
        let deadline = new Date();
        deadline.setSeconds(deadline.getSeconds() + timerDuration);
        return deadline;
    };

    useEffect(() => {
        clearTimer(getDeadTime());
    }, []);

    const onClickReset = () => {
        clearTimer(getDeadTime());
    };

    return (
        <div className="App">
            <Typography
                sx={{
                    fontSize: fontSize,
                    color: 'primary.main',
                    margin: 0,
                }}>
                {timer}
            </Typography>
            {reset && <button onClick={onClickReset}>Reset</button>}
        </div>
    );
};

export default CountdownTimer;
